export enum RecordStatus {
    Add,
    Edit,
    Delete
}